module.exports = __webpack_public_path__ + "article-7051a3ee/deckblatt-fuer-die-bewerbung-gestal-b229d8e79d3d780c572714207484e4c9.jpeg";